goog.provide('el8.appchart.refpanel.compareRefpanel');

goog.require('el8.appchart.refpanel.util');
goog.require('el8.app.shared.dialog.enterpriseImportPatientFTUX');
goog.require('el8.appservice.notifier');
goog.require('el8.ptdata.plrCollaborators');
goog.require('el8.template.appchart.refpanel.compareRefpanel');
goog.require('el8.tourguide.InfoBox');
goog.require('el8.uiwidget.TabbedNav');
goog.require('el8.util.base');


/**
 * This is a dialog for viewing the clinical profiles of PLR collaborators
 *
 * The design of this dialog is somehwat complex because we want to display a
 * "new item" count next to each collaborator tab, but doing that accurately
 * requires fetching the clinical profile associated with that collaborator.
 * Rather than fetch once for the count and a second time when viewing a tab,
 * we cache the results in a simple dictionary which persists for the page session.
 */
el8.appchart.refpanel.compareRefpanel = (function() {

    var currentCollabPatientId = null;
    var FTUX = false;
    var isClinicalProfileUpdateNew = false;

    /* The first layer of keys are otherPatientIds
     * The second layer of keys are section names
     * Then the values are the camel-cased JSON from the server */
    var cachedResults = {};

    var futxBubble = new el8.tourguide.InfoBox();
    var tabWaitingToRender = null;

    var title = el8Globals.FEATURES.PLR4Everyone ? 'Compare Clinical Profiles from Care Team' : 'Compare Clinical Profiles';

    var that = new el8.uiwidget.NewDialog({
        title: title,
        autoHeight: true,
        position: 'center',
        width: 800,
        showXButton: true,
        contentFn: el8.template.appchart.refpanel.compareRefpanel.skeleton
    });

    var super_init = that._init;
    that._init = function() {
        super_init.call(that);

        that._tabbedNav = new el8.uiwidget.TabbedNav();
        that._tabbedNav.init({
            wrapper: $('.tab-container', that.getContentElt()),
            tabSectionClass: 'el8VerticalTabSection',
            tabItemClass: 'el8CompareRefpanelTabItem',
            tabTemplateFn: el8.template.appchart.refpanel.compareRefpanel.refpanelTab
        });

        bindTriggers();
    };

    var super_show = that.show;
    that.show = function(spec) {
        spec = spec || {};
        FTUX = spec.FTUX || null;
        super_show.call(that);

        if (FTUX) {
            _.delay(function () {
                futxBubble.show({
                    styleClass: 'el8FTUEBox',
                    contentFn: el8.template.app.shared.dialog.enterpriseImportPatientFTUX.compareRefpanelBubble,
                    height: 190,
                    width: 200,
                    left: that.getContainer().offset().left - 215,
                    top: that.getContainer().offset().top - 5,
                    zIndex: $.ui.dialog.maxZ + 1
                });
            },
            1000);
        }

        updateCollaboratingPracticeList(true);
        that.unhighlightTrigger();
    };

    var super_hide = that.hide;
    that.hide = function() {
        if (FTUX) {
            futxBubble.hide();
            el8.app.shared.dialog.enterpriseImportPatientFTUX.show({lhsImported: 0});
        }

        // forcing a refresh on the PLR/compare profile state when we close the compare profile dialog
        el8.appchart.mainFeeds.plrNotification.refresh();

        var collab = el8.ptdata.plrCollaborators.getByKey(currentCollabPatientId);
        el8.util.amplitude.logCompareClinicalProfilefromCareTeam({action: "Close", comparing_practice: collab._practiceId});

        super_hide.call(that);
        currentCollabPatientId = null;
        tabWaitingToRender = null;
    };

    that.highlightTrigger = function() {
        // dot starts hidden and needs inline-block, so can't use .show()
        $('.compare-refpanel-trigger-dot').css('display', 'inline-block');
    };

    that.unhighlightTrigger = function() {
        $('.compare-refpanel-trigger-dot').hide();
    };

    // check to see if we have items to do compare profile against
    that.checkPlrProfileStatus = function(callbackFn) {
        $.el8_ajax({
            type: 'GET',
            url: el8.service.urls.get('plrProfileCheckForNew'),
            success: function(data) {
                if (data)
                {
                    that.highlightTrigger();
                    isClinicalProfileUpdateNew = true;
                }
                else
                {
                    that.unhighlightTrigger();
                    isClinicalProfileUpdateNew = false;
                }
                if (callbackFn) {
                    callbackFn(data);
                }
            }
        });
    };

    // Returns clinical profile update button's New status
    that.getIsClinicalProfileUpdated = function() {
        return isClinicalProfileUpdateNew;
    }

    /* The left and right side of the dialogs are independently scrollable,
     * and the right side of the dialog has a non-scrollable area on top. */
    var super_adjustPosition = that.adjustPosition;
    that.adjustPosition = function() {
        var $content = that.getContentElt();
        var $rhsHeader = $('.cp-details-header-container', $content);
        var $rhsContent = $('.cp-details-container', $content);
        var $lhsContent = $('.practice-select-pane', $content);

        // clear the previously set height before calculating what we need
        // (otherwise $lhsContent and $rhsContnet won't ask for more than already have)
        $lhsContent.height('');
        $rhsContent.height('');

        super_adjustPosition.call(that); // let the dialog contents adapt to the screen size
        var availHeight = $content.height() - 1;

        // figure out what we actually can give them
        $lhsContent.height(availHeight);
        $rhsContent.height(availHeight - $rhsHeader.outerHeight());
    };

    function bindTriggers() {
        that.getContentElt()
            .on('click', '.jump-link',  function() {
                var section = $(this).data('section');
                var $header = $('.cp-'+section+'-summary-header', that.getContentElt());
                var $rhsContent = $('.cp-details-container', that.getContentElt());
                var collab = el8.ptdata.plrCollaborators.getByKey(currentCollabPatientId);
                el8.util.amplitude.logCompareClinicalProfilefromCareTeam({action: "Select tab", comparing_practice: collab._practiceId, selected_tab: section})
                $rhsContent.scrollTo($header);

            }).on('click', '.cp-details-mark-reviewed-trigger',  function() {
                markAsReviewed(currentCollabPatientId);
                var collab = el8.ptdata.plrCollaborators.getByKey(currentCollabPatientId);
                el8.util.amplitude.logCompareClinicalProfilefromCareTeam({action: "Acknowledge", comparing_practice: collab._practiceId});

            }).on('click', '.import-trigger',  function() {
                var itemId = $(this).data('id');
                var sectionName = $(this).parents('.cp-section').data('section');
                var otherPatientId = currentCollabPatientId;

                el8.appservice.notifier.notify("Importing item from collaborator's chart...");
                importItem(otherPatientId, itemId, function() {
                    el8.appservice.notifier.notify("Imported item from collaborator's chart.");

                    var collab = el8.ptdata.plrCollaborators.getByKey(otherPatientId);

                    // get displayed items (to change the new status / counts)
                    updateCollabsAndShowPane(collab);

                    el8.util.amplitude.logCompareClinicalProfileSingleImport(sectionName);
                });

            }).on('click', '.import-all-trigger',  function() {
                var $this = $(this);
                var sectionName = $this.data('section');
                var otherPatientId = currentCollabPatientId;

                var $items = getSectionContainer(sectionName).find('.profile-item');
                var itemIds = getItemIdsFromProfileElems($items);
                importItemsInBatches(otherPatientId, itemIds);

                var collab = el8.ptdata.plrCollaborators.getByKey(otherPatientId);
                el8.util.amplitude.logCompareClinicalProfileImportAllByCategory({category: sectionName, number: $items.length});

                // get displayed items (to change the new status / counts)
                updateCollabsAndShowPane(collab);
            }).on('click', '.import-new-trigger',  function() {
                var $this = $(this);
                var sectionName = $this.data('section');
                var otherPatientId = currentCollabPatientId;

                var $items = getSectionContainer(sectionName).find('.new-profile-item');
                if (!$items.length) {
                    el8.appservice.notifier.notify('No new items in this section to import.');
                    return;
                }
                el8.util.amplitude.logCompareClinicalProfileImportNewByCategory({category: sectionName, number: $items.length});
                var itemIds = getItemIdsFromProfileElems($items);
                importItemsInBatches(otherPatientId, itemIds);

                var collab = el8.ptdata.plrCollaborators.getByKey(otherPatientId);

                // get displayed items (to change the new status / counts)
                updateCollabsAndShowPane(collab);
            }).on('click', '.import-all-sections-trigger',  function() {
                var otherPatientId = currentCollabPatientId;
                var importType = $(this).data('type');

                var $items;
                if (importType === 'all') {
                    $items = that.getContentElt().find('.profile-item');
                } else if (importType === 'new') {
                    $items = that.getContentElt().find('.new-profile-item');
                } else {
                    return;
                }

                var itemIds = getItemIdsFromProfileElems($items);
                importItemsInBatches(otherPatientId, itemIds);

                // if we imported _everything_ we've reviewed this profile
                markAsReviewed(otherPatientId);

                var collab = el8.ptdata.plrCollaborators.getByKey(otherPatientId);
                el8.util.amplitude.logCompareClinicalProfilefromCareTeam({action: "Import new & acknowledge", comparing_practice: collab._practiceId});

                // get displayed items (to change the new status / counts)
                updateCollabsAndShowPane(collab);
            }).on('click', '.care-team-no-member-prompt',  function() {
                // NOTE: pretty sure we don't use this, will know if we see amplitude events
                el8.appchart.mgr.thirdpane.showLetter({
                    type: 'letter',
                    autoAddToCareTeam: true,
                    clickSource: 'care-team-no-member'
                });
                that.hide();
            }).on('click', ".tabbed-nav-item", function() {
                var collab = el8.ptdata.plrCollaborators.getByKey(currentCollabPatientId);
                el8.util.amplitude.logCompareClinicalProfilefromCareTeam({action: "Change selected practice", comparing_practice: collab._practiceId});
            });
    }

    // Fetch the list of collaborators and render them as tabs
    function updateCollaboratingPracticeList(showFirst) {

        el8.ptdata.plrCollaborators.load(function() {
            var $practiceList = $('.practice-list-container', that.getContentElt());
            var $noCollabsMsg = $('.no-collaborators-msg', that.getContentElt());

            if (!el8.ptdata.plrCollaborators.all().length) {
                $practiceList.hide();
                $noCollabsMsg.show();

                if (el8Globals.FEATURES.PLR4Everyone) {
                    var $noCareTeamMsg = $('.care-team-no-member-prompt', that.getContentElt());
                    var careTeamProviders = el8.ptdata.careTeamProviders.sortedByGroup({ indicatePracticeUsers: true, indicateCurrentUser: true });
                    if (careTeamProviders.activeMembers.length +
                        careTeamProviders.inactiveMembers.length < 2) {
                        $noCareTeamMsg.show();
                    } else {
                        $noCareTeamMsg.hide();
                    }
                }

                that.adjustPosition();
                return;
            }

            $practiceList.show();
            $noCollabsMsg.hide();

            // Display the collaborators that have seen this patient most recently first
            var collabs = el8.ptdata.plrCollaborators.all();
            var sortedCollabs = _.sortBy(collabs, function(c) { return c.getLastSeen() || 0; });
            sortedCollabs = sortedCollabs.reverse();

            sortedCollabs.forEach(function(collab) {
                if (!that._tabbedNav.getTabExists(collab.getPatientId())) {
                    createCollaboratingPracticeTab(collab);
                }
            });

            if (showFirst) { that._tabbedNav.showTab(that._tabbedNav.getFirstTab()); }
            that.adjustPosition();

        }, true);
    }

    function updateCollabsAndShowPane(paneCollab) {
        var collabs = el8.ptdata.plrCollaborators.all();

        for (var i=0; i < collabs.length; i++) {
            var collab = collabs[i];
            // get displayed items (to change the new status / counts)
            fetchItemsForOtherPatient(collab.getPatientId(), function() {
                if (collab.getPatientId() === paneCollab.getPatientId()) {
                    showDetailsPane(collab);
                }
            });
        }
    }

    /* When we create a new tab, we're going to want to fetch all of its profile items,
     * even before the user clicks on the tab, in order to calculate a new item count.
     *
     * We won't make the user wait for the items before showing them the tab name,
     * but that means we may asked to show the tab contnets before we've fetched its data.
     * To deal with this, when each tab finishes, we'll check tabWaitingToRender and see
     * if someone has registered to have a tab shown when its data is ready.
     */
    function createCollaboratingPracticeTab(collab) {

        var $detailsContainer = $('.cp-details-container', that.getContentElt());
        fetchItemsForOtherPatient(collab.getPatientId(), function() {
            if (tabWaitingToRender === collab.getPatientId()) {
                $detailsContainer.removeClass('el8Loading');
                that._tabbedNav.showTab(collab.getPatientId());
                tabWaitingToRender = null;
            }
        });

        that._tabbedNav.addTab({
            name: collab.getPatientId(),
            // this will get passed through to the tabTemplateFn
            collaborator: collab.asSoyMap(),
            showTabFn: function() {
                if (isFetchCompleteForPatient(collab.getPatientId())) {
                    showDetailsPane(collab);
                } else {
                    tabWaitingToRender = collab.getPatientId();
                    $detailsContainer.addClass('el8Loading');
                }
            },
            updateCountFn: function(name, $content, $count) {
                var countDict = getNewCountDict(collab);

                if (countDict.total) {
                    $count.addClass('el8TabItemCountHighlight');
                } else {
                    $count.removeClass('el8TabItemCountHighlight');
                }
                updateJumpLinkCounts(countDict);
                return countDict.total;
            }
        });
    }

    // Caches the data for each section of the profile for a given patient and
    // optionally runs a callback when all of those sections have been fetched/cached
    function fetchItemsForOtherPatient(otherPatientId, callbackFn) {
        if (cachedResults[otherPatientId] === undefined) {
            cachedResults[otherPatientId] = {};
        }

        var fetchSection = function(opts) {
            var sectionName = opts.sectionName;
            var urlKey = opts.urlKey || sectionName;
            var url = el8.service.urls.get('plrProfileFetchSection', [otherPatientId, urlKey]);

            return $.el8_ajax({
                type: 'GET',
                url: url,
                success: function(data) {
                    var camelData = el8.util.keysFromUnderscoreToCamel(data);
                    cachedResults[otherPatientId][sectionName] = camelData;
                }
            });
        };

        var allergiesAjax = fetchSection({ sectionName: 'allergies' });
        var intolsAjax = fetchSection({ sectionName: 'intols', urlKey: 'drug-intolerances' });
        var problemsAjax = fetchSection({ sectionName: 'problems' });
        var historyAjax = fetchSection({ sectionName: 'history', urlKey: 'history-items' });
        var medsAjax = fetchSection({ sectionName: 'meds' });
        var vaccinesAjax = fetchSection({ sectionName: 'vaccines', urlKey: 'immunizations' });

        $.when(allergiesAjax, intolsAjax, problemsAjax, historyAjax, medsAjax, vaccinesAjax).done(function() {
            cachedResults[otherPatientId]['loaded'] = true;
            that._tabbedNav.updateTabCount(otherPatientId);
            if (callbackFn) { callbackFn(); }
        });

    }

    // Renders the profile for a specific collaborator
    function showDetailsPane(collab) {
        // The header includes the collaborator details, last-reviewed info, and jump links
        var $headerContainer = $('.cp-details-header-container', that.getContentElt());
        $headerContainer.html(
            el8.template.appchart.refpanel.compareRefpanel.CPDetailsHeader({
                collaborator: collab.asSoyMap()
            })
        );

        // Render an empty list of sections we can populate
        var $detailsContainer = $('.cp-details-container', that.getContentElt());
        $detailsContainer.html(
            el8.template.appchart.refpanel.compareRefpanel.CPDetails()
        );

        // Then populate those sections
        // (data should have been previously loaded by fetchItemsForOtherPatient)
        var populateSection = function(opts) {
            var sectionName = opts.sectionName;
            var templateFn = opts.templateFn;

            var data = opts.data;
            if (!data) {
                data = cachedResults[collab.getPatientId()][sectionName];
            }
            data.lastReviewTime = collab.getLastReviewTime();

            getSectionContainer(sectionName).html(
                templateFn(data)
            ).removeClass('el8Loading');
        };

        populateSection({
            sectionName: 'allergies',
            templateFn: el8.template.appchart.refpanel.compareRefpanel.allergySection
        });
        populateSection({
            sectionName: 'intols',
            templateFn: el8.template.appchart.refpanel.compareRefpanel.intolSection
        });
        populateSection({
            sectionName: 'problems',
            templateFn: el8.template.appchart.refpanel.compareRefpanel.problemSection
        });

        var historyRawData = cachedResults[collab.getPatientId()]['history'];
        var historySectionOrder = [
            'past','surgical','family','social','cognitive','functional','habits','diet','exercise'
        ];
        var historyData = {
            pairs: _.sortBy(_.pairs(historyRawData), function(p) {
                if (historySectionOrder.indexOf(p[0]) === -1) { return 99999; }
                else { return historySectionOrder.indexOf(p[0]); }
            })
        };
        populateSection({
            sectionName: 'history',
            templateFn: el8.template.appchart.refpanel.compareRefpanel.historySection,
            data: historyData
        });

        var medsRawData = cachedResults[collab.getPatientId()]['meds'];
        populateSection({
            sectionName: 'perm-rx',
            templateFn: el8.template.appchart.refpanel.compareRefpanel.medThreadSection,
            data: { items: medsRawData['permRxThreads'] }
        });
        populateSection({
            sectionName: 'perm-otc',
            templateFn: el8.template.appchart.refpanel.compareRefpanel.medThreadSection,
            data: { items: medsRawData['permOtcThreads'] }
        });
        populateSection({
            sectionName: 'temp-meds',
            templateFn: el8.template.appchart.refpanel.compareRefpanel.medThreadSection,
            data: { items: medsRawData['tempThreads'] }
        });

        populateSection({
            sectionName: 'vaccines',
            templateFn: el8.template.appchart.refpanel.compareRefpanel.vaccineSection
        });

        // And update counts of new items
        updateJumpLinkCounts(getNewCountDict(collab));

        currentCollabPatientId = collab.getPatientId();
        that.adjustPosition();
    }

    function updateJumpLinkCounts(countDict) {
        for (var section in countDict) {
            if (countDict.hasOwnProperty(section) && countDict[section]) {
                var $jumpLink = $('.jump-link[data-section="' + section + '"]', that.getContentElt());
                if (!$jumpLink.length) { continue; }
                var $count = $('.section-count', $jumpLink);
                $count.html(el8.template.appchart.refpanel.compareRefpanel.jumpLinkCount({
                    count: countDict[section]
                }));
            }
        }
    }

    function markAsReviewed(otherPatientId) {
        $.el8_ajax({
            type: 'POST',
            url: el8.service.urls.get('plrProfileMarkViewed', [otherPatientId]),
            success: function(data) {
                var collab = el8.ptdata.plrCollaborators.getByKey(otherPatientId);

                // update our last review time
                collab.setLastReviewUserId(data.last_review_user_id);
                collab.setLastReviewTime(data.last_review_time);

                // and our displayed items (to change the new status / counts)
                fetchItemsForOtherPatient(collab.getPatientId(), function() {
                    showDetailsPane(collab);
                });
            }
        });
    }

    function importItem(otherPatientId, itemId, callbackFn) {
        _importItems(otherPatientId, [itemId], callbackFn);
    }
    // A profile might be several hundred items, and waiting on all
    // of those items to finish might be painful. A request per item
    // though can cause Chrome to become suspicious in Incognito mode
    // and also means only ~5 items can be processed by the server at once
    // (request concurrency). So chunking is a nice midway point.
    function importItemsInBatches(otherPatientId, itemIds, callbackFn) {
        if (!itemIds || !itemIds.length) {
            el8.appservice.notifier.notify("No items to import.");
            return;
        }

        var BATCH_SIZE = 20;
        var itemCount = itemIds.length;
        var batchCount = Math.ceil(itemCount / BATCH_SIZE);

        // every batch will call this when done; after batchCount calls, doneFn will run
        var doneFn = function(data) {
            el8.appservice.notifier.notify("Imported items from collaborator's chart.");
            if (callbackFn) { callbackFn(data); }
        };
        var batchCheckedIn = _.after(batchCount, doneFn);

        el8.appservice.notifier.notify("Importing items from collaborator's chart...");
        for (var i=0; i <= itemCount; i += BATCH_SIZE) {
            var batch = itemIds.slice(i, i+BATCH_SIZE);
            _importItems(otherPatientId, batch, batchCheckedIn);
        }
    }

    function _importItems(otherPatientId, itemIds, callbackFn) {
        $.el8_ajax({
            type: 'POST',
            url: el8.service.urls.get('plrProfileImportItem', [otherPatientId]),
            data: JSON.stringify({ item_ids: itemIds }),
            success: function(jsonList) {
                if (!jsonList || !jsonList.length) { return; }

                jsonList.forEach(function(data) {
                    var mClass = el8.model.idToModelClass(data.id);
                    if (mClass === 'PatientHistoryItem') {
                        // el8.ptdata.historyItems isn't actually an entity set - it's
                        // a wrapper around a series of entity sets
                        el8.ptdata.historyItems.create(data);
                    } else {
                        var entitySet = el8.ptdata.getEntitySet(mClass);
                        entitySet.create(data);
                    }

                    // highlight the new item for 10s
                    el8.appchart.refpanel.util.highlightEntry(data.id);
                });

                if (callbackFn) { callbackFn(); }
            }
        });
    }

    function getSectionContainer(sectionName) {
        return $('.cp-'+sectionName+'-section', that.getContentElt());
    }

    function getItemIdsFromProfileElems($items) {
        return $items.map(function() {
            var $this = $(this);
            // look first for an import-id (for MedOrders, where we import the Thread instead)
            var importId = $this.data('import-id');
            // then fallback to the standard id
            if (!importId) { importId = $this.data('id'); }
            return importId;
        }).toArray();
    }

    // Note: this logic is duplicated inside the compareRefpanel tmeplate.
    // We could consider annotating objects with whether they are new,
    // and then having the templates use that flag
    function getNewCountDict(collab) {
        if (!isFetchCompleteForPatient(collab.getPatientId())) {
            return { total: 0};
        }

        // In general, an item is new if its createDate is more recent than our
        // last review time for a profile (or if we don't have a review time at all).
        // For med threads, we look at the createDate of the thread's latest order
        // We also check the "duplicate" flag that's new from the server to see if it's new
        var genericIsNewFn = function(a) {
            if (a.duplicate) { return false; }
            if (!collab.getLastReviewTime()) { return true; }
            var createDate = el8.service.tz.newTzDateTime(a.createDate);
            return el8.util.datecompare.cmp(createDate, collab.getLastReviewTime()) === 1;
        };
        var threadIsNewFn = function(a) {
            if (a.duplicate) { return false; }
            if (!collab.getLastReviewTime()) { return true; }
            var createDate = el8.service.tz.newTzDateTime(a.latestOrder.createDate);
            return el8.util.datecompare.cmp(createDate, collab.getLastReviewTime()) === 1;
        };

        var countDict = {};
        var allData = cachedResults[collab.getPatientId()];

        countDict['allergies'] = _.filter(allData.allergies.items, genericIsNewFn).length;
        countDict['intols'] = _.filter(allData.intols.items, genericIsNewFn).length;
        countDict['problems'] = _.filter(allData.problems.items, genericIsNewFn).length;
        countDict['vaccines'] = _.filter(allData.vaccines.items, genericIsNewFn).length;

        var flattenedHistory = _.flatten(_.values(allData.history));
        countDict['history'] = _.filter(flattenedHistory, genericIsNewFn).length;

        countDict['perm-rx'] = _.filter(allData.meds.permRxThreads, threadIsNewFn).length;
        countDict['perm-otc'] = _.filter(allData.meds.permOtcThreads, threadIsNewFn).length;
        countDict['temp-meds'] = _.filter(allData.meds.tempThreads, threadIsNewFn).length;

        countDict['total'] = _.reduce(_.values(countDict), function(memo, num) { return memo + num; }, 0);
        return countDict;
    }

    function isFetchCompleteForPatient(otherPatientId) {
        return cachedResults[otherPatientId]['loaded'];
    }


    return that;

})();
